
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/1-field-lp/[slug]",
      function () {
        return require("private-next-pages/1-field-lp/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/1-field-lp/[slug]"])
      });
    }
  